module.exports = __webpack_public_path__ + "img/category-brand-hover.d7c4d6da.png";